firebird.controller('meetingLockedJoinRequestDeclinedCtrl', [
    '$window',
    'meetingService',
    function ($window, meetingService) {
        var self = this;
        self.getAppLogoURL = meetingService.getAppLogoURL;
    }
]);
